<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Saldo Cliente
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta corriente</span>
      <span> /</span>
      <span class="grey-text">Pagos</span>
      <span> /</span>
      <span>Saldo Cliente </span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body align-items-center">
        <div class="col" [ngClass]="{disabledContent: !enableClienteInputs}" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" #rutcliente formControlName="rutCliente"
              formatRut />
            <label for="rutcliente">RUT</label>
          </div>
        </div>
        <div class="col d-flex" [ngClass]="{disabledContent: !enableClienteInputs}" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarCliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;" *ngIf="clienteSeleccionado">
            {{ clienteSeleccionado.razon_social }}
          </h6>
        </div>
        <div class="col" style="max-width: 150px;">
          <mdb-checkbox formControlName="todosClientes">Todos</mdb-checkbox>
        </div>
      </div>
      <div class="row filtros-body align-items-center">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [multiple]="true" [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar ruta"
              [options]="optionsRutas" formControlName="rutas">
            </mdb-select>
            <label>Rutas</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar territorio" [options]="optionsTerritorio" formControlName="territorios">
            </mdb-select>
            <label>Territorios</label>
          </div>
        </div>
        <div class="col align-items-center" style="max-width: 300px;">
          <div class="md-form">
            <mdb-checkbox formControlName="saldoDistintoCero">Saldo distintos a 0</mdb-checkbox>
          </div>
        </div>
        <div class="col align-items-center" style="max-width: 300px;">
          <div class="md-form">
            <mdb-checkbox formControlName="sinClientesBloqueados">Sin clientes Bloqueados</mdb-checkbox>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between" *ngIf="listaRegistros">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Cliente</th>
            <th scope="col">Teléfono</th>
            <th scope="col">Saldos</th>
            <th scope="col">Cond. Pago</th>
            <!-- <th scope="col">Tipo de Cobro</th> -->
            <th scope="col">Vendedores</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaRegistros?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let reg of listaRegistros">
            <td>{{reg.rutFormato | rut}}</td>
            <td>{{reg.razonSocialCliente}}</td>
            <td>{{reg.telefono}}</td>
            <td>{{reg.saldo | numerico}}</td>
            <td>{{reg.condicion_pago_nombre}}</td>
            <!-- <td>{{reg.tipo_cobro_nombre}}</td> -->
            <td>{{reg.vendedores}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaRegistros?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaRegistros?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('PDF')">
      PDF
    </button> -->
  </div>
</div>


<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" (onSelectSingle)="onClienteSeleccionado($event)"
  queryType="ONLY_RUT_BLO_DESB" showInfoClienteInactivoBloqueado="true" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>